import React, { useState } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import "./Faq.css"; // Import the CSS file

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = [
    {
      question: "What types of cosmetic surgeries do you offer?",
      answer:
        '"At Surgery Saathi, we specialize in a variety of cosmetic surgeries, including: Rhinoplasty (Nose Surgery): To reshape or resize the nose. Gynecomastia Surgery: To reduce excess male breast tissue. Lipoma Removal: To safely remove fatty lumps from the body. We also offer other cosmetic procedures tailored to individual needs',
    },
    {
      question: "Who are the doctors at Surgery Saathi?",
      answer:
        "Our doctors are highly experienced cosmetic surgeons with years of expertise in their fields. We work with top surgeons across accredited hospitals, ensuring you receive care from some of the best in the industry.",
    },
    {
      question: "How does the consultation process work?",
      answer:
        "We offer  consultations where you can meet with one of our expert surgeons to discuss your goals and concerns. During the consultation, the doctor will assess your needs and recommend the best procedure for you. This is a no-obligation session to help you make an informed decision.",
    },
    {
      question: "Is cosmetic surgery safe?",
      answer: "Yes, cosmetic surgery is safe when performed by qualified professionals. At Surgery Saathi, your safety is our top priority. We use advanced techniques and work only with accredited hospitals that meet the highest medical standards.",
    },
    {
      question: "How long is the recovery time after surgery?",
      answer:
        "Recovery time varies depending on the type of surgery. Generally, minor procedures like lipoma removal may have short recovery periods of a few days, while  surgeries like rhinoplasty or gynecomastia may take a few weeks. Your surgeon will provide detailed post-surgery care instructions to ensure a smooth recovery.",
    },
    {
      question:'How do I schedule a consultation?',
      answer:"Scheduling a consultation is easy! You can book online through our website, or you can call us directly at +91-8882852726. We offer no-obligation consultations to help you get started on your cosmetic surgery journey."
    }
  ];

  return (
    <section className="faq pt-120 pb-120 faq_home_main_container">
      <div className="container">
        <Row>
          <Col className="main_col_after">
            <h5 className="we_offer_home_h5" style={{ textAlign: "center" }}>
              Have Questions? Find Answers!
            </h5>
            <div className="we_offer_home_divs" style={{ textAlign: "center" }}>
              Welcome to our FAQs section, where we've compiled answers to some
              of the most common questions about our services.
            </div>
          </Col>
        </Row>
        {/* <div className="title-section text-center">
          <h2 className="display-4 fw-semibold mb-3 mb-lg-4">
            Have Questions? Find Answers!
          </h2>
          <p className="text-n500 l-text mb-60">
            Welcome to our FAQs section, where we've compiled answers to some of
            the most common questions about our services.
          </p>
        </div> */}
        <Row className="gy-4 align-items-center">
          <Col lg={6} className="text-center">
            <img
              src="https://img.freepik.com/free-vector/surgery-isometric-flowchart-with-surgeons-patients-operating-table_1284-58746.jpg?t=st=1737301730~exp=1737305330~hmac=ca6343df6c2c7e2fbf138ba6fefe2dcabfb7f0813c71e90d9bd2d0cf960fcee8&w=900"
              className="max-unset faq-img-tagss"
              alt="FAQ Illustration"
            />
          </Col>
          <Col lg={6}>
            <div className="accordion">
              {faqData.map((faq, index) => (
                <Card
                  key={index}
                  className="accordion-item"
                  style={{ padding: "0px" }}
                >
                  <Card.Header style={{ padding: "0px", marginBottom: "10px" }}>
                    <Button
                      className={`accordion-button ${
                        activeIndex === index ? "" : "collapsed"
                      }`}
                      onClick={() => toggleAccordion(index)}
                    >
                      {faq.question}
                    </Button>
                  </Card.Header>
                  <Card.Body
                    className={activeIndex === index ? "" : "collapse"}
                  >
                    {faq.answer}
                  </Card.Body>
                </Card>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Faq;
